module.exports = __webpack_public_path__ + "static/sign-1-49dbb72c715c53afd795197bfda74aed.jpg";